var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<section id=\"planosindicados-errors\">\n    <div class=\"planosindicados-errors-wrapper\">\n        <p class=\"planosindicados-success\">\n            Erro interno no servidor\n        </p>\n    </div>\n</section>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./resources/templates/elements/error.hbs
// module id = 258
// module chunks = 0